import z from "zod";

/**
 * ExcluirObraAreaServicosSchema
 */

export const ExcluirObraAreaServicosSchema = z.object({
  areas: z.array(z.number(), { required_error: 'Este campo deve ser preenchido!' }),
  checklists: z.array(z.number(), { required_error: 'Este campo deve ser preenchido!' }),
});

/**
 * ExcluirObraAreaServicosForm
 */

export type ExcluirObraAreaServicosForm = z.infer<typeof ExcluirObraAreaServicosSchema>;